/* PerriPaws product page behaviour: variants, gallery, quantity, sticky bar, recommendations */
(function () {
  'use strict';
  if (window.PerriPawsProductInit) return;
  window.PerriPawsProductInit = true;

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function initProduct(root) {
    if (!root || root._ppReady) return;
    root._ppReady = true;

    var dataEl = qs('[data-pp-product-json]', root);
    var data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [] };
    var form = qs('[data-pp-main-form]', root);
    var idInput = form ? qs('[data-pp-variant-id]', form) : null;
    var atc = form ? qs('[data-pp-atc]', form) : null;
    var buyNow = form ? qs('[data-pp-buy-now]', form) : null;
    var priceNow = qs('[data-pp-price-now]', root);
    var priceWas = qs('[data-pp-price-was]', root);
    var priceSave = qs('[data-pp-price-save]', root);
    var sticky = qs('[data-pp-sticky]', root);
    var stickyMeta = sticky ? qs('[data-pp-sticky-meta]', sticky) : null;
    var stickyBtn = sticky ? qs('[data-pp-proxy-atc]', sticky) : null;
    var track = qs('[data-pp-gallery-track]', root);
    var thumbs = qsa('[data-pp-thumb]', root);

    /* ---------- Gallery ---------- */
    /* Every slide after the first is loading="lazy", and the browser only starts the fetch
       once the slide has already been scrolled into view. Clicking a colour therefore
       scrolled to that colour's photo and left the shopper looking at an empty cream frame,
       still unloaded more than a second later. Prime the slide we are about to show, plus
       its immediate neighbours, so the image is already on its way before the scroll runs. */
    function primeSlide(index) {
      if (!track) return;
      for (var i = index - 1; i <= index + 1; i++) {
        var s = track.children[i];
        if (!s) continue;
        var img = s.querySelector('img');
        if (img && img.loading === 'lazy') {
          img.loading = 'eager';
          if (i === index) img.fetchPriority = 'high';
        }
      }
    }

    function goToSlide(index, smooth) {
      if (!track) return;
      var slide = track.children[index];
      if (!slide) return;
      primeSlide(index);
      /* Same reasoning as scrollIntoStrip. This one happens to come out right today because
         .pp-gallery__main is positioned and sits flush against the track, but it is one
         stray padding or border away from the same fault, so measure it the safe way. */
      var target = track.scrollLeft + (slide.getBoundingClientRect().left - track.getBoundingClientRect().left);
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      /* A smooth scroll is right for a step of one, which is what a thumbnail next to the
         current one or an arrow key asks for. It is wrong for a jump across the gallery:
         selecting a colour whose photo sits fifteen slides away sent the track animating
         through fifteen thousand pixels of other images, which reads as the gallery
         malfunctioning rather than as a transition. Anything beyond a neighbouring slide
         goes straight there. */
      var far = Math.abs(target - track.scrollLeft) > track.clientWidth * 1.5;
      if (smooth === false || reduce || far) {
        track.scrollTo({ left: target, behavior: 'auto' });
      } else {
        track.scrollTo({ left: target, behavior: 'smooth' });
        /* Some browsers and embedded webviews ignore a programmatic smooth scroll on this
           track entirely and leave it exactly where it was, which made every thumbnail
           click and every variant image change do nothing at all. Check a moment later and
           jump straight to the slide if it has not moved. */
        clearTimeout(track.ppScrollCheck);
        track.ppScrollCheck = setTimeout(function () {
          if (Math.abs(track.scrollLeft - target) > 4) {
            track.scrollTo({ left: target, behavior: 'auto' });
          }
        }, 400);
      }
      setActiveThumb(index);
    }
    /* offsetLeft is measured from the nearest positioned ancestor, not from the element you
       happen to be scrolling. .pp-gallery__thumbs is a scroll container but is not
       positioned, so every thumb reported body-relative coordinates: on a 2384px monitor the
       centring margin on .pp-pdp (max-width 1320px) plus its gutter put roughly 554px of
       phantom offset into each call, which slammed the thumbnail strip toward its far end on
       any click and left a different thumbnail sitting under the cursor. Measuring against
       the scrolling box itself is correct whatever the ancestors are doing. */
    function scrollIntoStrip(el, pad) {
      var box = el.parentNode;
      if (!box || box.scrollWidth <= box.clientWidth) return;
      var left = box.scrollLeft + (el.getBoundingClientRect().left - box.getBoundingClientRect().left) - pad;
      box.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }
    function setActiveThumb(index) {
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      if (thumbs[index]) scrollIntoStrip(thumbs[index], 20);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goToSlide(parseInt(t.getAttribute('data-pp-thumb'), 10)); });
    });
    if (track) {
      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          setActiveThumb(index);
          qsa('video', track).forEach(function (v, i) { if (!v.paused && v.closest('[data-index]') && parseInt(v.closest('[data-index]').getAttribute('data-index'), 10) !== index) v.pause(); });
        }, 90);
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        var index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        if (e.key === 'ArrowRight') { e.preventDefault(); goToSlide(Math.min(index + 1, track.children.length - 1)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goToSlide(Math.max(index - 1, 0)); }
      });
      /* The gallery is a scroll-snap track, so the browser restores its scrollLeft on a
         reload or back navigation and can leave the PDP parked on a later slide. The page
         must always open on the product's first media (the featured image), so reset once
         on load unless the shopper has already started browsing the gallery. */
      var browsed = false;
      track.addEventListener('pointerdown', function () { browsed = true; }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { browsed = true; }); });
      var openOnFirst = function () {
        if (browsed || track.scrollLeft === 0) return;
        track.scrollTo({ left: 0, behavior: 'auto' });
        setActiveThumb(0);
      };
      openOnFirst();
      window.addEventListener('load', openOnFirst);
    }
    function goToMedia(mediaId) {
      if (!track || !mediaId) return;
      var slide = qs('[data-media-id="' + mediaId + '"]', track);
      if (slide) goToSlide(parseInt(slide.getAttribute('data-index'), 10));
    }

    /* ---------- Variants ---------- */
    var groups = qsa('[data-pp-option-index]', root);
    function selectedOptions() {
      return groups.map(function (g) {
        var checked = qs('[data-pp-option-input]:checked', g);
        return checked ? checked.value : null;
      });
    }
    function findVariant(options) {
      return data.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === options[i]; });
      })[0];
    }
    function updateAvailabilityMarks(options) {
      groups.forEach(function (g, gi) {
        qsa('[data-pp-option-input]', g).forEach(function (input) {
          var test = options.slice();
          test[gi] = input.value;
          var match = data.variants.filter(function (v) {
            return v.options.every(function (o, i) { return o === test[i]; });
          })[0];
          var label = qs('label[for="' + input.id + '"]', g);
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
        });
        var sel = qs('[data-pp-option-selected]', g);
        if (sel) sel.textContent = options[gi] || '';
      });
    }
    function setButtons(variant) {
      var available = !!(variant && variant.available);
      var label = !variant ? (window.PerriPaws.strings.unavailable || 'Unavailable') : (available ? 'Add to Cart' : 'Sold Out');
      if (atc) { atc.disabled = !available; atc.textContent = label; }
      if (buyNow) buyNow.disabled = !available;
      if (stickyBtn) { stickyBtn.disabled = !available; stickyBtn.textContent = label; }
    }
    function onVariantChange() {
      var options = selectedOptions();
      var variant = findVariant(options);
      updateAvailabilityMarks(options);
      setButtons(variant);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceNow) priceNow.textContent = variant.price;
      /* The struck price and the saving badge are one unit: a variant with no
         compare-at, or a compare-at at or below its price, must show neither, or
         the previous variant's discount is left standing over the new price. */
      var hasSaving = !!(variant.compareAt && variant.save > 0);
      if (priceWas) {
        priceWas.hidden = !hasSaving;
        priceWas.innerHTML = hasSaving
          ? '<span class="pp-visually-hidden">Regular price </span>' + variant.compareAt
          : '';
      }
      if (priceSave) {
        priceSave.hidden = !hasSaving;
        priceSave.textContent = hasSaving ? variant.save + '% OFF' : '';
      }
      qsa('[data-pp-cta-price]').forEach(function (el) { el.textContent = variant.price; });
      if (stickyMeta) stickyMeta.textContent = (data.hasOnlyDefault ? '' : variant.title + ' · ') + variant.price;
      if (variant.mediaId) goToMedia(variant.mediaId);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      root.dispatchEvent(new CustomEvent('pp:variant:change', { bubbles: true, detail: variant }));
    }
    groups.forEach(function (g) {
      g.addEventListener('change', onVariantChange);
    });

    /* Clicking the option that is already selected fires no change event, so nothing ran and
       the click looked broken. It happens on arrival: the gallery opens on the product's first
       media, which is often a banner rather than a colour, so the shopper sees "Blue" in the
       picker, taps Blue to see it, and the picture does not move. Treat any option click as a
       request to see that option's photo, whether or not the selection actually changed. */
    groups.forEach(function (g, gi) {
      g.addEventListener('click', function (e) {
        var lab = e.target.closest ? e.target.closest('label[for]') : null;
        if (!lab) return;
        var input = document.getElementById(lab.getAttribute('for'));
        if (!input || input.checked === false) return;
        var probe = selectedOptions();
        probe[gi] = input.value;
        var match = findVariant(probe);
        if (match && match.mediaId) goToMedia(match.mediaId);
      });
    });

    if (groups.length) updateAvailabilityMarks(selectedOptions());

    /* Version steps. Where an option is a version crossed with a colour the markup carries a
       button per version above the colour rows. Picking a version selects the first colour in
       it that is actually buyable and hides the other versions' colours, so the shopper makes
       the decision that changes the product and the price first and the colour second.
       Everything still runs through the same radios, so nothing here knows about variants. */
    qsa('[data-pp-optsteps]', root).forEach(function (wrap) {
      var steps = qsa('[data-pp-optstep]', wrap);
      var grps = qsa('[data-pp-optgrp]', wrap);
      if (!steps.length || steps.length !== grps.length) return;
      wrap.classList.add('pp-optsteps--on');

      function sync() {
        var checked = qs('[data-pp-option-input]:checked', wrap);
        var active = 0;
        grps.forEach(function (g, i) { if (checked && g.contains(checked)) active = i; });
        steps.forEach(function (s, i) { s.setAttribute('aria-pressed', i === active ? 'true' : 'false'); });
        grps.forEach(function (g, i) { g.hidden = i !== active; });
      }

      steps.forEach(function (s, i) {
        s.addEventListener('click', function () {
          var inputs = qsa('[data-pp-option-input]', grps[i]);
          var pick = inputs.filter(function (inp) {
            var lab = qs('label[for="' + inp.id + '"]', grps[i]);
            return lab && !lab.classList.contains('is-unavailable');
          })[0] || inputs[0];
          if (!pick) return;
          pick.checked = true;
          pick.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      wrap.addEventListener('change', sync);
      sync();
    });

    /* ---------- Selling plans ---------- */
    var planField = form ? qs('[data-pp-selling-plan]', form) : null;
    qsa('[data-pp-plan-input]', root).forEach(function (input) {
      input.addEventListener('change', function () { if (planField) planField.value = input.value; });
      if (input.checked && planField) planField.value = input.value;
    });

    /* ---------- Quantity ---------- */
    var qtyInput = form ? qs('[data-pp-qty-input]', form) : null;
    qsa('[data-pp-qty-step]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var next = (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.getAttribute('data-pp-qty-step'), 10);
        qtyInput.value = Math.max(1, next);
      });
    });

    /* ---------- Proxy Add to Cart buttons (sticky bar, mid-page and final CTA) ---------- */
    document.addEventListener('click', function (e) {
      var proxy = e.target.closest('[data-pp-proxy-atc]');
      if (!proxy || !atc) return;
      e.preventDefault();
      if (atc.disabled) {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
    });

    /* ---------- Sticky bar ---------- */
    var sentinel = qs('[data-pp-atc-sentinel]', root);
    if (sticky && sentinel && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', past);
          sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
          if (stickyBtn) stickyBtn.tabIndex = past ? 0 : -1;
          document.body.classList.toggle('pp-has-sticky', past);
        });
      });
      io.observe(sentinel);
    }

    /* ---------- Recently viewed (localStorage) ---------- */
    try {
      var key = 'pp-recently-viewed';
      var list = JSON.parse(localStorage.getItem(key) || '[]').filter(function (h) { return h !== data.handle; });
      list.unshift(data.handle);
      localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
    } catch (err) {}
  }

  /* ---------- Section-rendered product lists (related, complementary, recently viewed) ---------- */
  function loadRecommendations(el) {
    if (el._ppLoaded) return;
    el._ppLoaded = true;
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = qs('[data-pp-recs-source]', doc);
        var target = qs('[data-pp-recs-target]', el);
        var cards = fresh ? qsa('[data-pp-card-wrap]', fresh) : [];
        if (!cards.length || !target) return;
        target.innerHTML = '';
        cards.forEach(function (c) { target.appendChild(c); });
        el.hidden = false;
        el.dispatchEvent(new CustomEvent('pp:recs:loaded', { bubbles: true }));
      })
      .catch(function () {});
  }

  function loadRecentlyViewed(el) {
    if (el._ppLoaded) return;
    el._ppLoaded = true;
    var current = el.getAttribute('data-current');
    var handles = [];
    try { handles = JSON.parse(localStorage.getItem('pp-recently-viewed') || '[]'); } catch (e) {}
    handles = handles.filter(function (h) { return h && h !== current; }).slice(0, 4);
    if (!handles.length) return;
    var target = qs('[data-pp-recs-target]', el);
    var root = (window.PerriPaws.routes.root || '/').replace(/\/$/, '');
    Promise.all(handles.map(function (h) {
      return fetch(root + '/products/' + encodeURIComponent(h) + '?section_id=pp-product-card-render')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (results) {
      var added = 0;
      results.forEach(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = qs('[data-pp-card-wrap]', doc);
        if (card) { target.appendChild(card); added++; }
      });
      if (added) el.hidden = false;
    });
  }

  /* "Add the set" — adds every available single-variant product shown in the pairs grid plus the current selection */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pp-add-set]');
    if (!btn) return;
    e.preventDefault();
    var section = btn.closest('[data-pp-pairs]');
    var items = [];
    var main = qs('[data-pp-main-form]');
    if (main) {
      var mid = qs('[data-pp-variant-id]', main);
      var q = qs('[data-pp-qty-input]', main);
      if (mid && mid.value) items.push({ id: parseInt(mid.value, 10), quantity: parseInt(q && q.value, 10) || 1 });
    }
    qsa('[data-pp-product-form] input[name="id"]', section).forEach(function (input) {
      items.push({ id: parseInt(input.value, 10), quantity: 1 });
    });
    if (!items.length) return;
    btn.disabled = true;
    fetch(window.PerriPaws.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'pp-cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.status) {
          var errBox = document.querySelector('[data-pp-cart-error]');
          if (errBox) { errBox.textContent = json.description || json.message; errBox.hidden = false; }
          window.PerriPaws.openDrawer(document.getElementById('pp-cart-drawer'), btn);
          return;
        }
        if (window.PerriPaws.cartType === 'page') { window.location.href = window.PerriPaws.routes.cart; return; }
        var html = json.sections && json.sections['pp-cart-drawer'];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = qs('[data-pp-cart-drawer-content]', doc);
          var current = qs('[data-pp-cart-drawer-content]');
          if (fresh && current) {
            current.replaceWith(fresh);
            qsa('[data-pp-cart-count]').forEach(function (c) { c.textContent = fresh.getAttribute('data-cart-count'); });
          }
        }
        window.PerriPaws.openDrawer(document.getElementById('pp-cart-drawer'), btn);
      })
      .finally(function () { btn.disabled = false; });
  });

  /* "Write a Review" opens the Judge.me review form when the widget has loaded; otherwise scrolls to the reviews */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pp-write-review]');
    if (!btn) return;
    e.preventDefault();
    var section = btn.closest('section') || document;
    var link = qs('.jdgm-write-rev-link, .jdgm-rev-widg__write-rev-link, [data-jdgm-write-review]', section);
    if (link) { link.click(); return; }
    var widget = qs('.pp-prev__widget', section) || section;
    widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  function init() {
    qsa('[data-pp-product]').forEach(initProduct);
    qsa('[data-pp-recs]').forEach(loadRecommendations);
    qsa('[data-pp-recently-viewed]').forEach(loadRecentlyViewed);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    qsa('[data-pp-product]', e.target).forEach(function (el) { el._ppReady = false; initProduct(el); });
    qsa('[data-pp-recs]', e.target).forEach(loadRecommendations);
  });
})();
